import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import ShipperTable from './ShipperTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function ShipperListView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.shippers')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.shippers')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ShipperTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}